import moment from 'moment'
import axios from 'axios'

export type LicenseInfo = {
  licenseNumber: string,
  fileId: string,
  filename: string,
  mimeType: string,
  size: string,
  createdAt: string
}

export const licenseService = {
  placeholderFile(
    filename: string,
    mimeType: string,
    size: number,
    createdAt: string
  ) {
    const file = new File([], filename, {
      type: mimeType,
      lastModified: moment(createdAt).unix()
    })
    Object.defineProperty(file, 'size', { value: size })

    return file
  },

  promptDownload(file: File) {
    const url = URL.createObjectURL(file)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = file.name

    anchor.addEventListener('click', () => {
      setTimeout(() => {
        URL.revokeObjectURL(url)
        anchor.remove()
      }, 0)
    }, false)
    anchor.click()
  },

  async download(companyId: string, filename = 'liquor-license') {
    const res = await axios.get(`/api/restaurants/${ companyId }/liquor-license`, {
      responseType: 'blob'
    })
    const file = new File([res.data as Blob], filename, {
      type: res.headers['content-type']
    })
    return this.promptDownload(file)
  },

  async info(companyId: string): Promise<LicenseInfo | null> {
    try {
      const licenseInfo = (await axios.get(
        `/api/restaurants/${ companyId }/liquor-license/info`
      )).data as LicenseInfo
      return licenseInfo
    } catch (err) {
      return null
    }
  },

  async save(companyId: string, number: string, fileOrId: File | string) {
    const formData = new FormData()
    const {file, fileId} = fileOrId instanceof File
      ? {file: fileOrId, fileId: undefined}
      : {file: new File([], 'liquor-license'), fileId: fileOrId}

    formData.append('file', file)
    formData.append('data', JSON.stringify({
      fileId,
      licenseNumber: number
    }))

    return (await axios.post(
      `/api/restaurants/${ companyId }/liquor-license`,
      formData,
      { headers: { 'content-type': 'multipart/form-data' } }
    )).data as LicenseInfo
  }
}
